import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";
import {Button} from "reactstrap";
import UniversalModalOverride from "components/UniversalModalOverride";
import API from "@beardeddevops/react.api";
import Types from "../../../../../constants/Types";


const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'Acquisitions',
		url: '/acquisitions',
		icon: 'download',
	},
];



export default class Acquisitions extends Framework.Components.View {

	constructor(props) {
		super(props);
		this.state.backdrop = true;
		this.state.modalAcquisition = false;
		this.state.closeModal = 0;
		this.state.bypass = false;
	}

	handlingToggle = () => {
		if (this.state.backdrop !== 'static'){
			this.setState({modalAcquisition: !this.state.modalAcquisition});
		} else {
			if (this.state.closeModal > 0 || this.state.bypass){
				this.setState({closeModal: 0});
				this.setState({backdrop: true});
				this.setState({modalAcquisition: !this.state.modalAcquisition});
			} else {
				this.setState({closeModal: 1});
				API.Toast.info('You have unsaved changes. Click again to close modal.', {
					position: API.Toast.POSITION.TOP_CENTER,
					autoClose: 4000
				});
			}
		}
	}

	handleSetTotal = (totalCount) => {
		this.setState({totalCount});
	}

	render() {
		return (
			<div className="container-fluid">
				<Framework.Components.PageBar
					breadcrumbs={breadcrumbsStatic}
					history={this.props.history}
				>
					<div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
						{this.state.totalCount > 0 && (
							<div style={{
								position: 'absolute',
								right: '50%',
								transform: 'translateX(50%)',
								color: '#666',
								fontSize: '0.9em',
								fontWeight: '500',
								pointerEvents: 'none'
							}}>
								{this.state.totalCount + " total firearms"}
							</div>
						)}
							<Button data-id={"add-acquisition"} onClick={this.toggle('modalAcquisition')} size={"sm"} color="primary">
								<i className="fa fa-download"/>&nbsp;&nbsp;Add Acquisition
							</Button>
					</div>
				</Framework.Components.PageBar>

				<Collections.Acquisitions
					history={this.props.history}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					locations={this.props.locations}
					states={this.props.states}
					scannedCode={!this.state['modalAcquisition'] ? this.props.scannedCode : null}
					showDateRangeSearch={true}
					setTotalCount={this.handleSetTotal}
				/>

				{/*Don't pass toggle if passing showModal*/}
				<UniversalModalOverride
					showModal={this.state.modalAcquisition}
					locations={this.props.locations}
					states={this.props.states}
					name={"Acquisition"}
					object={Objects.Acquisition}
					history={this.props.history}
					reportClose={this.reportClose('modalAcquisition')}
					afterSave={() => {this.refreshPage(); this.setState({bypass: false})}}
					handleToggle={this.handlingToggle}
					size={"xl"}
					objectProps={{
						modalState: this.state['modalAcquisition'],
						scannedCode: this.state['modalAcquisition'] ? this.props.scannedCode : null,
						setBackdrop: (backdrop) => this.setState({backdrop}),
						setBypass: (bypass) => this.setState({bypass})
					}}
				/>
			</div>
		);
	}
}